import React, { Component } from "react";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faClose, faDownload} from "@fortawesome/free-solid-svg-icons";
export default class PopupMostrarQr extends Component {
  constructor(props) {
    super(props);
  }


  render() {
    return (
        <div className="modal fade" id="modal-qr-generado" data-backdrop="false" >
          <div className="modal-dialog  modal-dialog-centered  modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">QR de Transferencia</h5>
              </div>
              <div className="modal-body" style={{textAlign: "center"}}>
                <img src={"data:image/jpeg;base64,"+this.props.imgQr} />
              </div>
              <div className="modal-footer">
                <div className="col-md-12">
                <div className="row">
                  <div className="col-md-6"><button type="button" className="btn btn-cu-quintary btn-consulta" data-dismiss="modal" aria-label="Close" >
                 <FontAwesomeIcon icon={faClose} /> Cerrar
                </button></div>
                  <div className="col-md-6"> <a className="btn btn-cu-primary" href={"data:image/jpeg;base64,"+this.props.imgQr} download="transfQR-cu24hs.jpg"> 
                  <FontAwesomeIcon icon={faDownload} /> Descargar imagen 
                </a></div>
                </div>
                </div>
              </div>  
            </div>
          </div>
        </div>
    );
  }
}
